import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { addService } from "../../../api/service/serviceapi";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import { BiSolidRightArrowSquare } from "react-icons/bi";

const AddService = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    slug: "",
    icon: null,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
 
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: "" }));
    }
  };

  const handleIconChange = (file) => {
    setFormData(prev => ({ ...prev, icon: file }));
    if (errors.icon) {
      setErrors(prev => ({ ...prev, icon: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Service name is required";
    }

    if (!formData.description.trim()) {
      newErrors.description = "Service description is required";
    }

    if (!formData.slug.trim()) {
      newErrors.slug = "Service slug is required";
    }

    if (!formData.icon) {
      newErrors.icon = "Service icon is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      showToast.error("Please fix all validation errors");
      return;
    }

    try {
      setLoading(true);

      const data = new FormData();
      data.append("name", formData.name.trim());
      data.append("description", formData.description.trim());
      data.append("slug", formData.slug.trim());
      data.append("icon", formData.icon);

      const response = await addService(data);

      if (response?.success) {
        showToast.success(response.message || "Service added successfully!");
        setTimeout(() => navigate(-1), 1200);
      } else {
        showToast.error(response?.message || "Failed to add service");
      }
    } catch (error) {
      console.error("Error adding service:", error);
      showToast.error(
        error?.response?.data?.message || 
        error?.message || 
        "Failed to add service"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-3 mb-3">
        <div
          className="d-flex align-items-center gap-2"
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          <FaArrowLeftLong />
          <h3 className="mb-0 management-tile ml-2">Add Service</h3>
        </div>
      </div>

      <div className="position-relative mb-4">
        <Row className="g-3">
    
          <Col className="mb-3" xs={12}>
            <label className="form-label">
              Upload Service Icon <span className="text-danger">*</span>
            </label>
            <UploadImage 
              onFileSelect={handleIconChange}
              multiple={false}
            />
            {errors.icon && (
              <small className="text-danger">{errors.icon}</small>
            )}
          </Col>

        
      

          <Col clas md={6}>
            <label className="form-label">
              Service Name <span className="text-danger">*</span>
            </label>
            <FormInput 
              placeholder="Enter service name" 
              value={formData.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
            {errors.name && (
              <small className="text-danger">{errors.name}</small>
            )}
          </Col>

          <Col md={6}>
            <label className="form-label">
              Service Slug <span className="text-danger">*</span>
            </label>
            <FormInput 
              placeholder="Enter service slug" 
              value={formData.slug}
              onChange={(e) => handleChange("slug", e.target.value)}
            />
            {errors.slug && (
              <small className="text-danger">{errors.slug}</small>
            )}
          </Col>

          <Col xs={12}>
            <label className="form-label">
              Service Description <span className="text-danger">*</span>
            </label>
            <FormInput
              placeholder="Enter service description"
              type="textarea"
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
            />
            {errors.description && (
              <small className="text-danger">{errors.description}</small>
            )}
          </Col>

          <Col xs={12} className="mt-3">
            <Button onClick={handleSubmit} disabled={loading}>
              {loading ? "Adding Service..." : "Add Service"}
            </Button>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AddService;